module.exports = __webpack_public_path__ + "img/play-active.e702a2b9.png";